import { getErrorMessage, getNetworkErrorMessage, HTTP_STATUS } from "../constants/http-codes-error-msg";
import { error } from "../components/notify/notify";
import { getDataFromLocalStorage, localStorageData, setDataToLocalStorage } from "./localStorage";
import { onLogout } from "../redux/actions/authActions";
import store from "../redux";

export const handleApiError = (error, customMessage) => {
  if (error.handled) {
    return;
  }

  if (error.response && error.response.status === HTTP_STATUS.UNAUTHORIZED) {
    messageAuth();
  } else if (error.response) {
    const msg = getErrorMessage(error.response.status);
    const content = (error.response && error.response.data) || error.message || error.toString();
    const errorMessage = content.message || content;
    if (!error.response) {
      const msg = getNetworkErrorMessage(error.code);
      if (msg) {
        return `${customMessage} ${msg}`;
      }
    }

    return `${customMessage} ${content.message || msg || ""}`;
    // return `${customMessage} ${content.message || content}`;
  }
  return null;
};

export const messageAuth = () => {
  const dispatch = store.dispatch;
  const isShowMessageAuth = +getDataFromLocalStorage(localStorageData.isShowMessageAuth);
  if (isShowMessageAuth) {
    console.log('set false');
    error(`Действие токена доступа истекло, вы будете перенапревлены на Авторизацию`, true);
    dispatch(onLogout());
  }
};